
import React from "react";
import "./FocusAreaPhilippines.css";
import {
    createTheme,
    ThemeProvider,
    Box,
    Typography
} from '@mui/material';
const card = {
  title: "Philippines",
  img: "/images/Home/philipphines_card.png", 
  items: [
    "Java",
    "SAP",
    "Gen AI",
    "Core Delivery",
    "Industry",
    "Leadership Development (PLC, Business Storytelling, Coaching, and Client Relations)"
  ],
  style: { top: "12%", left: "52%", width: "500px" }
};
const localTheme = createTheme({
  typography: {
    fontFamily: 'Graphik-Regular',
  },
});
const FocusAreaPhilippines = () => (
<ThemeProvider theme={localTheme}>
  <Box className="focus-ph-wrapper">
    <Box sx={{ width: "90%", margin: "auto", position: "relative" }}>
        <Typography variant="h4" color="primary" gutterBottom className="atc-header-apacfocusarea">
          Focus Area
        </Typography>
        <div className="header_focus_apac">
          <img src="images/Home/focusarea_line.png" alt="header_line" className="header_focus_line_img" />
        </div>
      </Box>

    <div className="map-stage">
      <img
        src="/images/Home/Phillippines.png" 
        alt="Philippines map"
        className="ph-map"
      />

      <div className="card_philipphines" style={card.style}>
        <img src={card.img} className="card-bg-ph" alt="Philippines card" />
        <div className="card-title-ph">{card.title}</div>
        <ul className="card-body-ph">
          {card.items.map((it) => (
            <li key={it}>{it}</li>
          ))}
        </ul>
      </div>
    </div>
  </Box>
  </ThemeProvider>
);

export default FocusAreaPhilippines;
